import axios from 'axios';

export const getAllProducts = () => {
  return axios.get(`${process.env.REACT_APP_API_URL}/product/getAll?limit=48`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getOneProduct = (productID) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/product/getDataProduct?productID=${productID}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const isLikedProduct = (productID) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/product/isLiked?productID=${productID}`,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
};

export const likeProduct = (productID, userID) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/product/like`,
    { productID, userID },
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
};

export const unlikeProduct = (productID, userID) => {
  return axios.delete(`${process.env.REACT_APP_API_URL}/product/unlike`, {
    data: { productID, userID },
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
};

export const getProductReviews = (productID, limit = 6, page = 1, typeSort) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/product/reviews?productID=${productID}&limit=${limit}&page=${page}&typeSort=${typeSort}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getEachNumofTypeRating = (productID) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/product/eachNumReviews?productID=${productID}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const suggestProductNames = (keyword, limit = 5) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/product/suggestNames?keyword=${keyword}&limit=${limit}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const searchProductsByName = (keyword, page = 1, limit = 20) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/product/searchByName?keyword=${keyword}&page=${page}&limit=${limit}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
